var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#159D12",
    fillOpacity: 0.11
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1336_1142",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1336_1142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3331 17.3336C17.6109 17.3336 17.847 17.2364 18.0414 17.0419C18.2359 16.8475 18.3331 16.6114 18.3331 16.3336C18.3331 16.0558 18.2359 15.8197 18.0414 15.6253C17.847 15.4308 17.6109 15.3336 17.3331 15.3336C17.0553 15.3336 16.8192 15.4308 16.6247 15.6253C16.4303 15.8197 16.3331 16.0558 16.3331 16.3336C16.3331 16.6114 16.4303 16.8475 16.6247 17.0419C16.8192 17.2364 17.0553 17.3336 17.3331 17.3336ZM17.3331 19.3336C17.6775 19.3336 17.9942 19.253 18.2831 19.0919C18.572 18.9308 18.8053 18.7169 18.9831 18.4503C18.7386 18.3058 18.4775 18.1947 18.1997 18.1169C17.922 18.0392 17.6331 18.0003 17.3331 18.0003C17.0331 18.0003 16.7442 18.0392 16.4664 18.1169C16.1886 18.1947 15.9275 18.3058 15.6831 18.4503C15.8609 18.7169 16.0942 18.9308 16.3831 19.0919C16.672 19.253 16.9886 19.3336 17.3331 19.3336ZM17.3331 20.6669C16.4109 20.6669 15.6247 20.3419 14.9747 19.6919C14.3247 19.0419 13.9997 18.2558 13.9997 17.3336C13.9997 16.4114 14.3247 15.6253 14.9747 14.9753C15.6247 14.3253 16.4109 14.0003 17.3331 14.0003C18.2553 14.0003 19.0414 14.3253 19.6914 14.9753C20.3414 15.6253 20.6664 16.4114 20.6664 17.3336C20.6664 18.2558 20.3414 19.0419 19.6914 19.6919C19.0414 20.3419 18.2553 20.6669 17.3331 20.6669ZM13.9997 20.6669C12.4553 20.278 11.1803 19.3919 10.1747 18.0086C9.16918 16.6253 8.66641 15.0891 8.66641 13.4003V9.33359L13.9997 7.33359L19.3331 9.33359V13.1169C19.0442 12.9725 18.7192 12.8614 18.3581 12.7836C17.997 12.7058 17.6553 12.6669 17.3331 12.6669C16.0442 12.6669 14.9442 13.1225 14.0331 14.0336C13.122 14.9447 12.6664 16.0447 12.6664 17.3336C12.6664 18.0225 12.797 18.6447 13.0581 19.2003C13.3192 19.7558 13.6497 20.2391 14.0497 20.6503C14.0386 20.6503 14.0303 20.653 14.0247 20.6586C14.0192 20.6642 14.0109 20.6669 13.9997 20.6669Z",
    fill: "#159D12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.24538996200f3e540ca5ae656f1d5e74.svg";
export { ForwardRef as ReactComponent };